/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Location, useLocation } from 'react-router-dom';

export default function useRouteTracker() {
  const location = useLocation();

  // Attempt to load initial state from session storage or default to an empty array
  const [previousPaths, setPreviousPaths] = useState<Location[]>(() => {
    const savedPaths = sessionStorage.getItem('previousPaths');
    return savedPaths ? JSON.parse(savedPaths) : [];
  });

  useEffect(() => {
    // Only update if the new path is different from the last path
    if (previousPaths[previousPaths.length - 1]?.pathname !== location?.pathname) {
      setPreviousPaths((prevPaths: Location[]) => {
        const newPaths = prevPaths.filter((p) => p.pathname !== location.pathname);
        // Add the new route to the end of the array and keep only the last five paths
        const updatedPaths = newPaths.concat(location).slice(-5);
        // Save the updated paths to session storage
        sessionStorage.setItem('previousPaths', JSON.stringify(updatedPaths));
        return updatedPaths;
      });
    }
  }, [location, previousPaths]);

  return previousPaths;
}
